import React, { useRef } from 'react';
// Import custom hooks
import useStepLogic from 'components/Form/useStepLogic';
// Import components
import SectionStepInfo from 'components/shared/SectionStepInfo/SectionStepInfo';
import Input from 'components/shared/FormElements/Input/textarea';
import useFormData from '../../../useFormData';
import Links from '../../../../shared/Link/Link';

const Fraud = () => {
  const formRef = useRef(); // Used so we can keep track of the form DOM element
  const { register } = useStepLogic(formRef); // Custom hook for handling continue button (validation, errors etc)

  const { handleSubmit, showGenericError, continueButton } = useStepLogic(formRef); // Custom hook for handling continue button (validation, errors etc)

  // Check it we are facing an existing user
  const { ExistingUser } = useFormData();

  // Logic used to validate fields
  const fieldValidation = (name) => {
    return register({ required: `${name} is required` });
  };

  return (
    <form onSubmit={handleSubmit} ref={formRef} autoComplete="on">
      {/* Subsection */}
      {!ExistingUser && (
        <SectionStepInfo section="Section 2 of 4" description="About your enquiry" />
      )}

      {/* Show generic error message */}
      {showGenericError}

      <fieldset className="wmcads-fe-fieldset wmcads-col-1">
        <legend className="wmcads-fe-fieldset__legend">
          <h2 className="wmcads-fe-question">Whistleblowing and fraud?</h2>
        </legend>

        <Links
          link="https://beta.wmca.org.uk/whistleblowing-policy/"
          classes="wmcads-m-b-lg"
          text="See our Whistleblowing policy"
          target="_blank"
        />
        <br />
        <Links
          link="https://beta.wmca.org.uk/anti-fraud-policy/anti-fraud-corruption-policy-and-procedures/"
          classes="wmcads-m-b-lg"
          text="See our anti-fraud policy"
          target="_blank"
        />

        <Input
          className="wmcads-col-1 wmcads-col-sm-3-4 wmcads-col-md-1-2"
          name="AllegationDetails"
          label="Allegation details"
          fieldValidation={fieldValidation('Allegation details')}
        />

        <Input
          className="wmcads-col-1 wmcads-col-sm-3-4 wmcads-col-md-1-2"
          name="ExtraAllegationDetails"
          label="Please provide any information that will help with the investigation of this allegation"
          fieldValidation={fieldValidation(
            'Please provide any information that will help with the investigation of this allegation'
          )}
        />
      </fieldset>

      {/* Continue button */}
      {continueButton()}
    </form>
  );
};

export default Fraud;
